__turbopack_context__.v({
  "align-center": "headline-module__hf9Mra__align-center",
  "align-left": "headline-module__hf9Mra__align-left",
  "align-right": "headline-module__hf9Mra__align-right",
  "headline-l": "headline-module__hf9Mra__headline-l",
  "headline-m": "headline-module__hf9Mra__headline-m",
  "headline-s": "headline-module__hf9Mra__headline-s",
  "headline-xs": "headline-module__hf9Mra__headline-xs",
});
